import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/preferences`

const getPreferences = (): AxiosPromise => apiFetch(URL, { method: `GET` })

export default getPreferences
